var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-btn',{ref:"cancel_changes_btn",attrs:{"color":"secondary","data-test-id":"cancel-changes"},on:{"click":_vm.on_click}},[_vm._v(_vm._s(_vm.l.t('app.cancel', 'Cancel')))])
}
var staticRenderFns = []

export { render, staticRenderFns }